import _ from 'lodash'
import defaultConfig from './default'
import orderService from 'service/order'
import paymentTypes from 'payment-types'
import ua from 'ua'

module.exports = _.merge({}, defaultConfig, {
  name: '招行',
  loginExtraHintText: '首次查询订单/优惠券需手机号验证',
  stripBrand: true,
  showUserEntry: false,
  supportZeroPay: true,
  hideReview: true,
	hideBuyNum: true,
  hideCredit: true,
  match () {
    let userAgent = navigator.userAgent.toLowerCase()
    return /cmblife/.test(userAgent)
  },
  login () {
    // 解循环依赖，更好的方式是把user中的zhaohangLogin沉淀到这里来
    const user = require('user')
    return user.zhaohangLogin()
  },
  pay (subjectId, subjectType, paymentAmount) {
    // 解循环依赖，同上
    const user = require('user')
    return user.zhaohangLogin().then(() => {
      orderService.unifiedPay({
        subjectId,
        subjectType,
        paymentAmount,
        paymentType: paymentTypes.zhaohang
      }).then(({ paymentParams }) => {
        if (ua.isProduct() || ua.isBeta()) {
          window.cmblife && window.cmblife.executeProtocol(paymentParams)
        } else {
          window.cmblife && window.cmblife.startSimulation(paymentParams)
        }
      }).catch((err) => {
        window.pnlogger.sendPageLog('response error:' + err)
      })
    })
  },
  goOrder () {
    const user = require('user')
    user.zhaohangLogin(location.protocol + '//' + location.host + location.pathname + '?action=goOrder').then(() => {
      const zhaohangGo = require('zhaohangSdk').zhaohangGo
      let toUrl = location.protocol + '//' + location.host + '/user/order.html'
      zhaohangGo(toUrl)
    })
  },
  goCoupon () {
    const user = require('user')
    user.zhaohangLogin(location.protocol + '//' + location.host + location.pathname + '?action=goCoupon').then(() => {
      const zhaohangGo = require('zhaohangSdk').zhaohangGo
      let toUrl = location.protocol + '//' + location.host + '/user/coupon.html'
      zhaohangGo(toUrl)
    })
  },
  orderBottomText: '查看2018年8月前的订单',
  moreOrder () {
    const loadZHSDK = require('zhaohangSdk').loadZHSDK
    const ZhaoHangOrder = ua.isProduct() ? 'https://movie.o2o.cmbchina.com/web/h5/cmblife/myShow.html' : 'http://103.243.255.145/web/h5/cmblife/myShow.html'
    loadZHSDK().then(() => {
      if (ua.isProduct() || ua.isBeta()) {
        window.location.href = ZhaoHangOrder
      } else {
        window.cmblife && window.cmblife.startSimulation(ZhaoHangOrder)
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/mods/channels/zhaohang.js